import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';


function App() {
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState(''); // Success or error message variant


  // Función para manejar el envío del formulario y enviar el correo de verificación
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Limpiar mensajes anteriores
    setMessage('');
    setVariant('');

    // Verificar que los campos no estén vacíos
    if (!email || !userId) {
      setMessage('Por favor, ingresa tu correo electrónico y tu identificador de usuario.');
      setVariant('danger');
      return;
    }
    try{
      const response = await fetch('https://api.grekad.cfcunap.cl/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId, email }),
      });

      const data = await response.json();
      if (data.success) {
        setMessage('Correo enviado con éxito. Verifica tu correo electrónico.');
        setVariant('success');
      } else {
        setVariant('danger');
        setMessage('Error al enviar el correo. Asegúrate de que los datos sean correctos.');
      }
    } catch (error) {
      setMessage('Hubo un error en la conexión con el servidor. Intenta nuevamente.');
      setVariant('danger');
    }
  };

  return (
    <Container className="mt-5">
      <h2>Verificación de Usuario</h2>
      <p>Ingresa tu run y tu fecha de nacimiento, si son correctos seras redirigido a la pagina de votación.</p>

      {message && <Alert variant={variant}>{message}</Alert>}
      {/* Formulario para ingresar ID de usuario y correo electrónico */}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formUserId" className="mb-3">
          <Form.Label>Run de Trabajador</Form.Label>
          <Form.Control
            type="text"
            placeholder="12123123-K"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control
            type="email"
            placeholder="Ingresa tu correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>  
        
        <Button variant="primary" type="submit">Enviar Correo de Verificación</Button>
      </Form>
    </Container>
  );
}

export default App;



